import { Delete } from "@mui/icons-material";

import CoAppDataGridDateTimeCell from "../../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import { CoAppDataGridActionsContainer } from "../../../../global/styled/global.styled";

export const roleIdpGroupColumns = ["actions", "name", "createdAt"];

export const getRoleSSOColumns = (
	loading,
	identityProviderName,
	removeIdPGroupFromRole
) => [
	{
		field: "name",
		headerName: identityProviderName ? `${identityProviderName} Group` : "Group",
		disableExport: true,
		sortable: true,
		editable: true,
		flex: 1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={params.row} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "createdAt",
		headerName: "Date Mapped",
		disableExport: true,
		sortable: true,
		editable: true,
		flex: 1,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		),
	},
	{
		field: "actions",
		disableExport: true,
		sortable: false,
		type: "actions",
		flex: .1,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<CoAppDataGridActionsContainer>
						<Delete
							onClick={() => {
								removeIdPGroupFromRole(params.row.id);
							}}
						/>
					</CoAppDataGridActionsContainer>
				}
				isLoading={loading}
			/>
		),
	},
];